import { Chip } from "@material-ui/core";
import { ClearAllProps } from "./clear-all.props";
import { useClearAllStyles } from "./clear-all.styles";

export const ClearAll = ({ onClick }: ClearAllProps) => {
  const classes = useClearAllStyles();

  return (
    <Chip className={classes.clearAll} label="Clear All" onClick={onClick} variant="outlined" />
  );
};
